import React from 'react';
import { WeeklyHours, DayHours } from '../services/storeHoursApiService.ts';
import './StoreHoursEditor.css';

interface StoreHoursEditorProps {
  hours: WeeklyHours;
  onChange: (hours: WeeklyHours) => void;
}

const DAYS = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' }
] as const;

const StoreHoursEditor: React.FC<StoreHoursEditorProps> = ({ hours, onChange }) => {
  const handleDayChange = (dayKey: keyof WeeklyHours, field: keyof DayHours, value: string | boolean) => {
    const updatedHours = {
      ...hours,
      [dayKey]: {
        ...hours[dayKey],
        [field]: value
      }
    };
    onChange(updatedHours);
  };

  const formatTimeForInput = (time: string): string => {
    // Convert "09:00" to "09:00" (already correct format)
    return time;
  };

  const formatTimeFromInput = (time: string): string => {
    // Convert input time to our format
    return time;
  };

  return (
    <div className="store-hours-editor">
      <div className="hours-grid">
        {DAYS.map(({ key, label }) => {
          const dayHours = hours[key];
          
          return (
            <div key={key} className="day-row">
              <div className="day-label">
                {label}
              </div>
              
              <div className="hours-controls">
                <label className="closed-checkbox">
                  <input
                    type="checkbox"
                    checked={dayHours.closed}
                    onChange={(e) => handleDayChange(key, 'closed', e.target.checked)}
                  />
                  <span>Closed</span>
                </label>
                
                {!dayHours.closed && (
                  <div className="time-inputs">
                    <div className="time-group">
                      <label>Open</label>
                      <input
                        type="time"
                        value={formatTimeForInput(dayHours.open)}
                        onChange={(e) => handleDayChange(key, 'open', formatTimeFromInput(e.target.value))}
                      />
                    </div>
                    
                    <div className="time-group">
                      <label>Close</label>
                      <input
                        type="time"
                        value={formatTimeForInput(dayHours.close)}
                        onChange={(e) => handleDayChange(key, 'close', formatTimeFromInput(e.target.value))}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StoreHoursEditor;